export enum campaignScreens {
	setup = 'setup',
	video = 'video',
	build = 'build',
	delivery = 'delivery',
	summary = 'summary',
}

export enum deliveryScreensEnum {
	delivery = 'delivery',
	sms = 'sms',
	email = 'email',
	nicheInbox = 'niche-inbox',
}

export enum buildScreensEnum {
	'video-page' = 'video-page',
	'widget' = 'widget',
}

export enum SummaryRouteEnum {
	COMPLETED = 'completed',
}

export type stepperCampaignType =
	| 'oneToOne'
	| 'oneToAll'
	| 'oneToAllNewStory'
	| 'oneToWorld'
	| 'oneToWorldNewStory'
	| 'collectVideos'
	| 'collectVideosSkipTemplates';

export enum campaignTypeEnum {
	oneToOne = 'oneToOne',
	oneToAll = 'oneToAll',
	oneToAllNewStory = 'oneToAllNewStory',
	oneToWorld = 'oneToWorld',
	oneToWorldNewStory = 'oneToWorldNewStory',
	collectVideos = 'collectVideos',
	reels = 'reels',
}

export enum PersonalizationEnum {
	oneToOne = 'oneToOne',
	oneToAll = 'oneToAll',
	oneToWorld = 'oneToWorld',
	collectVideos = 'collectVideos',
	reels = 'reels',
	SMS = 'sms',
	openSubmissions = 'openSubmissions',
	milestones = 'milestones',
	outreach = 'outreach',
	collectVideosSkipTemplates = 'collectVideosSkipTemplates', //TODO: REMOVE DEPRECATED: For campaigns that skip the templates step
}

export enum CreationMethod {
	createToDos = 'createToDos',
	videoFromLibrary = 'videoFromLibrary',
	openSubmissions = 'openSubmissions',
	collectVideos = 'collectVideos',
	noVideo = 'noVideo',
	mixed = 'mixed',
}

export enum DisplayMode {
	DEFAULT = 'default',
	EMBEDDED = 'embedded',
}

export type campaignCreationType = {
	personalization: PersonalizationEnum | null;
	creationMethod: CreationMethod | null;
	displayMode?: DisplayMode | null;
};

/** Here is where the campaigns are created from the dropdown */

export const oneToOneCampaign: campaignCreationType = {
	personalization: PersonalizationEnum.oneToOne,
	creationMethod: CreationMethod.createToDos,
};

export const oneToManyCampaign: campaignCreationType = {
	personalization: PersonalizationEnum.oneToAll,
	creationMethod: CreationMethod.createToDos,
};

export const collectVideosCampaign: campaignCreationType = {
	personalization: null,
	creationMethod: CreationMethod.collectVideos,
};

export const collectVideosCampaignOpenSubmissions: campaignCreationType = {
	personalization: PersonalizationEnum.openSubmissions,
	creationMethod: CreationMethod.collectVideos,
};

export const reelsCampaign: campaignCreationType = {
	personalization: PersonalizationEnum.reels,
	creationMethod: CreationMethod.mixed,
};

export const reelsEmbedCampaign: campaignCreationType = {
	personalization: PersonalizationEnum.reels,
	creationMethod: CreationMethod.mixed,
	displayMode: DisplayMode.EMBEDDED,
};

/** All the one to many campaigns*/

export const OneToManyCampaignTypes: string[] = [
	campaignTypeEnum.oneToAll,
	campaignTypeEnum.oneToAllNewStory,
];

export const OneToOneCampaignTypes: string[] = [campaignTypeEnum.oneToOne];

export const uploadAudienceHelpArticle =
	'https://nichepartnerresources.zendesk.com/hc/en-us/articles/42966977370900-Importing-Contacts-into-Niche-Engage-by-File';

export enum campaignResponseMessage {
	duplicatedName = 'One or several campaigns with this name already exist.',
	updatedSuccessfully = 'Campaign updated successfully',
}

export const UntitledCampaignName = 'Untitled Campaign';

export enum HotglueJobStatusEnum {
	STARTED = 'started',
	STOPPED = 'stopped',
	QUEUED = 'queued',
	COMPLETED = 'completed',
	CANCELLED = 'cancelled',
	PENDING_APPROVAL = 'pendingApproval',
	FAILED = 'failed',
	IN_PROGRESS = 'inProgress',
}

export const SelectDateAndTimeText =
	'Select a date and time to view it in your timezone.';

export const RepeatedCampaignNameErrorText =
	'This name is already in use. Please enter an unique name.';

export const ExpirationDateBeforeSendingErrorText =
	'Expiration date must be a after launching date.';
